import type { FaireProductEntity } from "../../entity_types/product";

export const p_n6zqaptsrg: FaireProductEntity = {
  token: "p_n6zqaptsrg",
  type: "product",
  name: "Unisex Quick-Dry Scrub Set - Short Sleeve Tops And Pants",
  brandToken: "b_4z8um3dept",
  brandName: "Sheer Trend",
  imageUrl:
    "https://cdn.faire.com/fastly/8549485491ea164ebddc0edd33f328435b05ef1c47bccf8acc24aecd1defba45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4c2e0ba7a3ed6334e43ad148cc6030381544a9a4cb48b038a60ecdad93e50e2.jpeg",
    "https://cdn.faire.com/fastly/090c5eedd899a878d47816f3cbf0aec9ebe226a129f2d0c56122f17e2d63eddc.jpeg",
    "https://cdn.faire.com/fastly/4832345d1986c50b119ae92a5a8f769b72139d708a2570e59173c6903ef9b5f2.jpeg",
    "https://cdn.faire.com/fastly/8f419d9a80bf84f2a18034650bc13cb77bfc5c15e4ba2e6bcdf5360b260be885.jpeg",
    "https://cdn.faire.com/fastly/8377bfa5b4a2eb68040306e765b039c21d228cb4b0e76be0360ae22fe803f642.jpeg",
    "https://cdn.faire.com/fastly/d78ea6fc7917a03f1d4c9e658697771e356abe6922ab8a4d9d133ef7ee1d05fe.jpeg",
    "https://cdn.faire.com/fastly/cc11cf5f04cb94299204a52b01a458b4989b2c009c6820e7c77a7e3f3dab7b42.jpeg",
    "https://cdn.faire.com/fastly/6e9b019a212ac1f2b3a7731b4041601b2e92514259352c5cd675249f547a2fad.jpeg",
    "https://cdn.faire.com/fastly/6e7b334fd42df92425211f8990536391283bece5adf82934f554030f6affd289.jpeg",
  ],
  priceDollars: 16.99,
  description:
    "\nMaterial:Dacron\n\nStyle:Loose\n\nFeature:Drawstring,Elasticity\n\nNeckline:V-neck\n\nOccasion:Workwear Suits\n\nSeasons:Spring,Summer,Autumn,Winter\n\nType:Two Pieces Set\n\nSleeve Length:1/4 Sleeve\n\nSleeve Style:Raglan Sleeve\n\nSize S (inch) : Pants length= 39.00 ; Bust= 40.95 ; Waist= 25.74 ; Shoulder= 15.99 ; Sleeve= 7.61 ; Hips= 40.17 ; Top Length= 25.74 ; \n\nSize M (inch) : Pants length= 39.78 ; Bust= 43.29 ; Waist= 27.69 ; Shoulder= 16.77 ; Sleeve= 7.80 ; Hips= 42.51 ; Top Length= 26.52 ; \n\nSize L (inch) : Pants length= 40.56 ; Bust= 45.63 ; Waist= 29.64 ; Shoulder= 17.55 ; Sleeve= 8.00 ; Hips= 44.85 ; Top Length= 27.30 ; \n\nSize XL (inch) : Pants length= 41.",
  tags: [],
  msrpDollars: 33.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:23.096Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
